(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-ugc';

  function play(button) {
    var video = button.parentElement.querySelector('.oddit-section-ugc__video');
    if (!video) return;

    // Muted is required for programmatic playback to survive autoplay policies.
    video.muted = true;
    video.controls = true;

    var started = video.play();
    // Older browsers return undefined rather than a promise.
    if (started && typeof started.catch === 'function') {
      started.catch(function () {
        video.controls = true;
      });
    }

    button.hidden = true;
  }

  // Entering fullscreen from the native controls leaves a paused video paused.
  function onFullscreenChange(video) {
    var active =
      document.fullscreenElement === video ||
      document.webkitFullscreenElement === video;
    if (active && video.paused) video.play();
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-oddit-ugc-play]').forEach(function (button) {
      button.addEventListener('click', function () {
        play(button);
      });
    });

    scope.querySelectorAll('.oddit-section-ugc__video').forEach(function (video) {
      var handler = function () {
        onFullscreenChange(video);
      };
      video.addEventListener('fullscreenchange', handler);
      video.addEventListener('webkitbeginfullscreen', handler);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector(SECTION_SELECTOR)) init(event.target);
  });
})();
